import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import * as Sentry from '@/core/sentry'
import { isWhitelistError } from '@/utils/api/whitelist'

export async function loadPrompts() {
  try {
    const url = withPbx('audio-files')

    const { data } = await http.get(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function deleteAudioFiles(audioFileIds: number[]) {
  try {
    const url = withPbx('audio-files')

    const { data } = await http.delete<{ updated: number[]; failed: number[] }>(
      url,
      { params: { audioFileIds } }
    )

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
